import { Component, Inject } from '@angular/core';
import { Representative } from '@shared/models/representative.model';
import { MAT_DIALOG_DATA, MatDialogClose } from '@angular/material/dialog';
import {
  Originator,
  OriginatorCreationRequestFields,
} from '@shared/models/originator.model';
import { Account } from '@shared/models/accounts.model';
import { CNPJ_MASK, CPF_MASK } from '@shared/constants';
import { NgxMaskPipe } from 'ngx-mask';
import { CurrentAccountDialog } from '@shared/models/current-account.model';
import { AssignorAgents } from '@shared/models';
import { mapAssignorAgentToRepresentative } from '@shared/components/summary-dialogs/mapper/representative.mapper';
import { NgIf, NgFor } from '@angular/common';
import { ZDialogComponent } from '../z-dialog/z-dialog.component';
import { MatAccordion, MatExpansionPanel, MatExpansionPanelHeader, MatExpansionPanelTitle } from '@angular/material/expansion';
import { ZButtonComponent } from '../z-button/z-button.component';
import { TelefonePipe } from '@shared/pipes';

@Component({
    selector: 'app-summary-dialogs',
    templateUrl: './summary-dialogs.component.html',
    styleUrls: ['./summary-dialogs.component.scss'],
    imports: [NgIf, ZDialogComponent, MatAccordion, NgFor, MatExpansionPanel, MatExpansionPanelHeader, MatExpansionPanelTitle, ZButtonComponent, MatDialogClose, TelefonePipe]
})
export class SummaryDialogComponent {
  representantes: Representative[] = [];
  originadores: OriginatorCreationRequestFields[] = [];

  maskpipe;
  cnpj_mask = CNPJ_MASK;
  cpf_mask = CPF_MASK;

  constructor(
    @Inject(MAT_DIALOG_DATA)
    public data: {
      dataRepre?: Representative[] | AssignorAgents[];
      dataOrigin?: OriginatorCreationRequestFields[];
    },
    private maskPipe: NgxMaskPipe
  ) {
    this.maskpipe = maskPipe;
  }

  ngOnInit() {
    this.loadRepresentantes(this.data.dataRepre);
    this.getOrigin(this.data.dataOrigin);
  }

  getOrigin(dataOrigin: OriginatorCreationRequestFields[] | undefined): void {
    this.originadores = dataOrigin || [];
  }

  private loadRepresentantes(data: Representative[] | AssignorAgents[] | undefined): void {
    if (data?.length && 'nomeRepresentante' in data[0]) {
      // Convertendo de AssignorAgents para Representative
      this.representantes = (data as AssignorAgents[]).map(mapAssignorAgentToRepresentative);
    } else {
      this.representantes = (data as Representative[]) || [];
    }
  }
}
